import { RouteObject } from 'react-router-dom';

import {
  Cases,
  CreateCase,
  EditCase,
  ViewCase,
  EditCaseOptions,
  CommerceTexts,
  CasesInformation,
  Minutes,
  MinuteEditor,
  ViewMinute,
  Invoices,
  InvoiceEditor,
} from '../..';
import { CustomerService } from '../../../CustomerService';
import { Authorize } from '@/components';
import { ROLES } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

export const CustomerServiceRoutes: RouteObject[] = [
  { path: '', element: <CustomerService /> },
  {
    path: 'cases-information',
    element: <CasesInformation />,

  },
  { path: 'cases', element: <Cases /> },
  { path: 'create/:shippingId', element: <CreateCase /> },
  { path: 'create', element: <CreateCase /> },
  { path: 'cases/:caseId', element: <ViewCase /> },
  { path: 'minutes', element: <Minutes /> },
  { path: 'minutes/create', element: <MinuteEditor /> },
  { path: 'minutes/:minuteId', element: <ViewMinute /> },
  { path: 'minutes/:minuteId/edit', element: <MinuteEditor /> },
  { path: 'invoices', element: <Invoices /> },
  { path: 'invoices/create', element: <InvoiceEditor /> },
  { path: 'invoices/:invoiceId/edit', element: <InvoiceEditor /> },
  {
    path: 'cases/:caseId/edit',
    element: (
      <Authorize
        permission={ROLES.ATC.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditCase />
      </Authorize>
    ),
  },
  {
    path: 'settings',
    element: (
      <Authorize
        permission={ROLES.ATC.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditCaseOptions />
      </Authorize>
    ),
  },
  {
    path: 'settings/commerce-texts',
    element: (
      <Authorize
        permission={ROLES.ATC.admin}
        fallback={<ErrorPage code={403} />}
      >
        <CommerceTexts />
      </Authorize>
    ),
  },
];
